var STATE_UNLOADED = 'state_unloaded'
var STATE_LOADING = 'state_loading'
var STATE_LOADED = 'state_loaded'
var STATE_SENDING = 'state_sending'
import REG from 'public/assets/img/registration/registrationloader.gif'
import $ from 'jquery'
import 'jquery-placeholder'
import RegistrationForm from './RegistrationForm'
import RegistrationUtil from './RegistrationUtil'
import Analytics from '../../analytics/utils/analytics'
import { getEnv } from 'aria-viewer/utils/environment'
import POWERED_BY_LOGO_PNG from 'public/assets/img/registration/Poweredby_logo.png'
import POWERED_BY_LOGO_PNG_2 from 'public/assets/img/registration/Poweredby_logo@2x.png'
import POWERED_BY_LOGO_PNG_3 from 'public/assets/img/registration/Poweredby_logo@3x.png'

// Preload the loading image right now, so it's ready to be displayed.
var $preloadLoadingImage = $(`<img src='${REG}' alt="registration loading" />`)

function Registration(opts) {
    opts = opts || {}
    // Params passed in initially
    this.testing = opts.testing
    this.mobile = opts.mobile
    this.tablet = opts.tablet
    this.loc_id = opts.loc_id
    this.loc_name = opts.loc_name
    this.inst_id = opts.inst_id
    this.inst_name = opts.inst_name
    this.userkey = opts.userkey
    this.sessionId = opts.sessionId
    this.source = opts.source
    this.original_source = opts.original_source
    this.hideLoading = !!opts.hideLoading
    this.formClass = opts.formClass || this.themes.default
    this.userOnCampus = opts.userOnCampus
    this.isRegInitByCTA = opts.isRegInitByCTA
    this.useSelectForVisitorType = opts.useSelectForVisitorType || false
    this.disablePlaceholder = opts.disablePlaceholder || false

    // Internal state of registration module
    this._state = STATE_UNLOADED

    this._emailEnabled = false
    this._assets = {}
    this._form = null
    this._forms = {}
    this._fields = {}
    this._focusedField = null
    this._onPolicyLinkClicked = opts.onPolicyLinkClicked || function() {}
    this._onFieldChange = opts.onFieldChange || function() {}
    this._onFieldError = opts.onFieldError || function() {}
    this._onFieldFocus = opts.onFieldFocus || function() {}
    this._onOpen = opts.onOpen || function() {}
    this._onClose = opts.onClose || function() {}
    this._onComplete = opts.onComplete || function() {}
    this._onResumePageScroll = opts.onResumePageScroll || function() {}
    this._onSubmit = opts.onSubmit || function() {}

    //this is the instance of the current guide
    this._guidePlayer =
        typeof DescriptionAudioController !== 'undefined' ? DescriptionAudioController.audioPlayer : null

    // Initialized on init method after server returns registration data
    this.$dialog = $(this._buildHtml())

    // Create wrapper for loading image
    this.$loading = $('<div class="registration-loading"></div>')
    this.$loading.append($preloadLoadingImage)

    this.registrationWrapAll = $(
        '<div class="registration-wrap-all ' +
            (this.mobile ? ' mobile' : ' desktop') +
            (this.formClass ? ' ' + this.formClass : '') +
            '"></div>'
    )
        .append(this.$dialog)
        .append(this.$loading)
        .appendTo(opts.parent || document.body)
    this.policyContainer = $('<div class="registration-mobile-policy"></div>')
    this.$close = this.$dialog.find('> .close-btn')
    this.$complete = this.$dialog.find('> .complete')
    this.$forms = opts.formContainer || this.$dialog.find('> .forms')

    this._applyBindings()
}

// Registration singleton
Registration._instance = null
Registration.instance = function(opts) {
    if (!Registration._instance) {
        Registration._instance = new Registration(opts)
    }
    return Registration._instance
}

Registration.isOpen = false

Registration.prototype = {
    _ajaxURLCache: {},
    themes: {
        default: 'registration-default',
        default_react: 'registration-default-react',
        material_ui: 'registration-material-ui',
    },

    open: function(options) {
        var loadedCb = (options && options.loadedCb) || function() {},
            allowCache = (options && options.allowCache) || true,
            isRegInitByCTA = (options && options.isRegInitByCTA) || false,
            formVisibleCb = (options && options.formVisibleCb) || function() {},
            errorCb = (options && options.errorCb) || function() {}

        //pause the guide when opening registration form
        this._pauseGuide()

        if (this._state === STATE_LOADED) {
            // Registration is already loaded - just show it
            // before opening check if it's opened by click cta button
            this.isRegInitByCTA = isRegInitByCTA
            loadedCb && loadedCb()
            this._show()
            formVisibleCb && formVisibleCb()
        } else if (this._state === STATE_UNLOADED) {
            var self = this

            // Set registration state as loading
            this._state = STATE_LOADING

            if (!this.hideLoading) {
                // Show loading animation on page
                this.$loading.addClass('show')
            }

            // Attempt to load from server
            this._loadFromServer(
                function(params) {
                    // Success - init registration
                    self._init(params)

                    // Set state to loaded
                    self._state = STATE_LOADED
                    loadedCb && loadedCb()

                    // if it's a long form it's registered
                    // set isRegInitByCTA to false to prevent
                    // formtitle change
                    if (params.form === 'long') {
                        $('.registration-form').addClass('registered')
                    }
                    self.$loading.removeClass('show')

                    // Show dialog
                    self._show()

                    //this callback is to let the tour know
                    //the reg form is visible
                    formVisibleCb && formVisibleCb()
                },
                function(message) {
                    // Error - reset back to unloaded state
                    self._state = STATE_UNLOADED
                    self.$loading.removeClass('show')

                    console.error(message)

                    errorCb && errorCb()
                },
                allowCache
            )
        }
    },

    closeByEnter: function(e) {
        /* Dismiss on enter of close */
        if (e.keyCode === 13) {
            this.close(true)
        }
    },

    close: function(isClickFromXButton) {
        if (isClickFromXButton) {
            this.$dialog.removeClass('show')
            this.registrationWrapAll.removeClass('show')
            Registration.isOpen = false

            //if the video guide was playing before, resume playing
            if (!this._isPaused && this._guidePlayer != null) {
                this._guidePlayer.toggle()
            }
            this._onClose(isClickFromXButton)
        }
    },

    hasField: function(fieldid) {
        return this._fields[fieldid] !== undefined
    },

    getField: function(fieldid) {
        return this._fields[fieldid] || null
    },

    getSvg: function(id) {
        return this._assets.svgs[id] || ''
    },
    focusField: function(fieldid) {
        var field = this._fields[fieldid]
        if (field && this._focusedField !== field) {
            this.blurField(fieldid)
            field.$html.addClass('focus')
            this._focusedField = field
            this._onFieldFocus(fieldid)
        }
    },

    isMaterialUI: function() {
        return this.formClass.indexOf(this.themes.material_ui) !== false
    },

    blurField: function(fieldid) {
        // Only blur field if it matches focused field
        if (typeof fieldid !== 'undefined') {
            // Skip blurring if not focused field
            var field = this._fields[fieldid]
            if (field !== this._focusedField) {
                return
            }
        }

        if (this._focusedField) {
            // hide select when no choice has been made so that the placeholder text does not conflict with the select value.
            var select = this._focusedField.$html.find('select')
            if (select) {
                if (select.val() == '') {
                    select.css('opacity', 0)
                }
            }
            if (
                !this.isMaterialUI() ||
                !(this._focusedField.value && this._focusedField.value.trim && this._focusedField.value.trim())
            ) {
                this._focusedField.$html.removeClass('focus')
            }
            var a = this._focusedField.$input
            this._focusedField = null
            a && a.trigger('blur')
        }
        if (fieldid == 'school') {
            // adding this so if field is school and on blur, resume default iscroll options
            this._onResumePageScroll()
        }
    },

    updateAllFieldViews: function(item) {
        this._onFieldChange(item)

        for (var fieldid in this._fields) {
            this._fields[fieldid].updateView()
        }

        var fieldsFilledCount = this.getFieldsCount(true)

        var requiredFieldsCount = this.getFieldsCount(false)

        var scope = this
        var $submitButton = $('.form-submit-btn')
        $submitButton.blur(function() {
            scope.$close.focus()
        })

        //if filled fields are greater than or
        //equal to required fields, add class to the
        //submit button to change color
        if (fieldsFilledCount >= requiredFieldsCount) {
            $submitButton.addClass('canSubmit')
        } else {
            if ($submitButton.hasClass('canSubmit')) {
                $submitButton.removeClass('canSubmit')
            }
        }
    },

    /**
     * this function will return the current fields that
     * are filled in and the total count of required fields
     *
     * @param  {[bool]} isFilledCount [this indicates to return required fields or filled fields]
     * @return {[int]}
     */
    getFieldsCount: function(isFilledCount) {
        var self = this
        return Object.keys(this._fields).reduce(function(count, fieldid) {
            var currentField = self._fields[fieldid]
            if (isFilledCount) {
                return currentField.required && currentField.isRelevant() && currentField.value != ''
                    ? count + 1
                    : count
            } else {
                return currentField.required && currentField.isRelevant() ? count + 1 : count
            }
        }, 0)
    },

    onDialogClick: function(callback) {
        this.$dialog.on('click', callback)
    },

    clearErrors: function() {
        for (var fieldid in this._fields) {
            // Clear field error on submit (if any)
            this._fields[fieldid].clearError()
        }
    },

    submitForm: function(form, callback) {
        // State must be 'loaded' in order to submit
        if (this._state !== STATE_LOADED) {
            return
        }

        // Maps field IDs to the values user-inputted values
        var fieldValues = {
            _: '', // force "values" to be sent in XHR, even if it's an empty object
        }

        for (var fieldid in this._fields) {
            var field = this._fields[fieldid]

            // Clear field error on submit (if any)
            field.clearError()

            // Only send relevant field values from current form
            if (field.form === this._form && field.isRelevant()) {
                fieldValues[fieldid] = field.getValue()
            }
        }

        var self = this

        // Set registration state as sending
        this._state = STATE_SENDING

        var onCampus = this.userOnCampus == undefined ? this._isUserOnCampus() : this.userOnCampus

        RegistrationUtil.ajax({
            url: `${getEnv('REACT_APP_BASE_URL')}/tour/Registration/ajaxSubmitForm${window.location.search}`,
            data: {
                testing: this.testing ? 1 : 0,
                loc_id: this.loc_id,
                userkey: this.userkey,
                sessionid: this.sessionId,
                original_source: this.original_source,
                source: this.source,
                form: form.id,
                on_campus: onCampus ? 1 : 0,
                values: fieldValues,
            },
            method: 'POST',
            success: function(res) {
                // Revert registration state to loaded
                self._state = STATE_LOADED

                if (res.success) {
                    $('.registration-form').addClass('registered')

                    self._openForm({
                        form: res.data.next_form,
                        email_sent: res.data.email_sent,
                    })
                } else {
                    var fieldErrors = []
                    // Apply error to fields
                    for (var fieldid in res.data) {
                        var field = self.getField(fieldid)

                        if (field) {
                            field.setError(res.data[fieldid])
                            fieldErrors.push(field.$html[0])
                        }
                    }

                    self._onFieldError(fieldErrors)

                    // Scroll to first error
                    self._form.scrollToFirstError()

                    // Alert message if not empty
                    if (res.message) {
                        alert(res.message)
                    }
                }

                callback && callback(true)
            },
            error: function(jqXHR, textStatus, errorThrown) {
                // Revert registration state to loaded
                self._state = STATE_LOADED

                console.log('submit error', jqXHR, textStatus, errorThrown)

                callback && callback(false)
            },
        })
    },

    _init: function(params) {
        this._assets = params.assets
        this._emailEnabled = params.email_enabled

        // Create and append the forms inside the registration dialog container
        this._buildForms(params.forms)

        // Make ie9 placeholders show
        this.$dialog.find('input[placeholder], textarea[placeholder]').placeholder()

        this._openForm({
            form: this.testing ? 'short' : params.form,
        })

        this.$close.append(this.getSvg('closeExit'))
        this._applyLateBindings()
    },

    /**
     * Open a form OR complete form registration if none provided
     *
     * @param opts
     * @param opts.form next form's ID to go to
     * @private
     */
    _openForm: function(opts) {
        var formID = opts.form

        // Hide prev form
        if (this._form) {
            this._form.$html.removeClass('show')
        }

        // Set next form
        this._form = this._forms[formID]

        if (this._form) {
            // Show next form
            this._form.$html.addClass('show')
            this.updateAllFieldViews()
        } else {
            // Submission is successful!

            var completeText = 'Thank you for submitting your information.'
            if (this._emailEnabled) {
                completeText += ' You will receive a confirmation email shortly.'
            }

            this._onComplete({
                completeText: completeText,
                emailEnabled: this._emailEnabled,
            })

            // No next form - show complete
            this.$complete.text(completeText).addClass('show')

            // when window is unbinded, remove page scroll event

            /*
				 *
				 TODO : THESE WERE RELATED TO LOGIC TO FIX THE IOS KEYBOARD ISSUES;
				 TODO : HAVE A FEW THINGS TO SORT OUT BUT A GOOD STARTING DIRECTION:
				 TODO : (check School.js for other code snippet)
				 *
				 * 	$( window).off('resize', this._onResumePageScroll);
				 *console.log('DEBUG : Submission successful and we\'re removing page scroll event');
				 *
				 */
        }
    },

    //this function will pause the guide
    _pauseGuide: function() {
        if (this._guidePlayer != null) {
            //set status of pausePrior, which denotes the status of the guide playing or paused
            //before the registration form button was clicked
            this._isPaused = !this._guidePlayer.isPlaying()

            //if the guide was playing, pause the guide
            if (this._guidePlayer.isPlaying()) {
                this._guidePlayer.toggle()
            }
        }
    },

    _show: function() {
        // if tour is launched from youvisit website
        // and it is launched by clicking cta button
        // update the text
        if (this.source == 'web' && this.isRegInitByCTA && !this.mobile) {
            this._form.title = 'Almost Done!'
            this._form.subtitle = 'Tell us more about yourself to receive information and customize your experience!'
            this._form.formTitle = 'Registration'
            this._form.updateFormTitleText()
        }

        // Show registration dialog with fullscreen overlay
        this.registrationWrapAll.addClass('show')
        this.$dialog.addClass('show')
        Registration.isOpen = true
        this._onOpen()
    },

    _buildHtml: function() {
        var html =
            '' +
            '<div class="registration-dialog">' +
            '<div class="complete"></div>' +
            '<div style="margin-bottom:60px;" class="forms"></div>' +
            '<div class="close-btn" role="button" aria-label="Close registration" tabindex="0"></div>' +
            '<div class="accesibilityLastItem" role="button" aria-label="Jumping to start of registration form" tabindex="0"></div>' +
            `<div class="poweredByLogo" role="button" aria-label="Powered By YouVisit">
                <a href="https://www.youvisit.com/" alt="Registration Powered-by-YouVisit" class="reg-newtab-link" target="_blank">
                    <img srcset="${POWERED_BY_LOGO_PNG_3} 3x, ${POWERED_BY_LOGO_PNG_2} 2x, ${POWERED_BY_LOGO_PNG} 1x"
                    src=${POWERED_BY_LOGO_PNG} />
                </a>
            </div>` +
            '</div>'
        return html
    },

    _applyBindings: function(callbacks) {
        this.$close.on('click', this.close.bind(this, true))
        this.$close.on('keydown', this.closeByEnter.bind(this))
        this.registrationWrapAll.on('click', this.close.bind(this, false))
    },

    _applyLateBindings: function(callbacks) {
        /**
         * Binding for reigstration policy url clicks.
         * Alt tag in form "Registratin Descriptor ", add click for full event.
         * Pass e ref as well.
         */
        var self = this
        this.policyContainer.find('a.reg-newtab-link').on('click', function(e) {
            self._onPolicyLinkClicked(e.currentTarget.getAttribute('alt') + ' Click', e)
        })
        this.registrationWrapAll.find('a.reg-newtab-link').on('click', function(e) {
            self._onPolicyLinkClicked(e.currentTarget.getAttribute('alt') + ' Click', e)
        })
    },

    _loadFromServer: function(success, error, allowCache) {
        var scope = this,
            url = `${getEnv('REACT_APP_BASE_URL')}/tour/Registration/ajaxLoad`,
            data = {
                testing: this.testing ? 1 : 0,
                loc_id: this.loc_id,
                original_source: this.original_source,
                source: this.source,
                userkey: this.userkey,
            }

        //Allow the user to cache the response from the server during this session
        if (allowCache) {
            var cacheUrl = url + '?'
            for (var key in data) {
                cacheUrl += key + '=' + data[key] + '&'
            }
            if (this._ajaxURLCache[cacheUrl]) {
                success(this._ajaxURLCache[cacheUrl])
                return
            }
        }
        RegistrationUtil.ajax({
            url: url,
            data: data,
            success: function(res) {
                if (res.success) {
                    scope._ajaxURLCache[cacheUrl] = res.data
                    success(res.data)
                } else {
                    // error - early exit
                    error(res.message)
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                switch (textStatus) {
                    case 'timeout':
                        error('Timed out')
                        return
                    case 'parseerror':
                        error('Error parsing response')
                        return
                    default:
                        error('General error')
                        return
                }
            },
        })
    },

    _buildForms: function(formDefs) {
        // Iterate through each form (e.g. short/long form(s))
        for (var formID in formDefs) {
            // formID is 'short'  'long'

            // Create the form and append its dom to a container. The form definition includes:
            //  - title
            //  - subtitle
            //  - image url
            //  - submit button text (e.g. CONTINUE / FINISH)
            //  - field definitions
            var form = new RegistrationForm({
                registration: this,
                formID: formID,
                loc_name: this.loc_name,
                definition: formDefs[formID],
                isRegInitByCTA: this.isRegInitByCTA,
                onComplete: this._onComplete,
                onSubmit: this._onSubmit,
                emailEnabled: this._emailEnabled,
                source: this.source,
            })

            this.$forms.append(form.$html)

            this.policyContainer.append(form.policyHTML())

            // Add form and append its html
            this._forms[formID] = form

            // Add to fields
            $.extend(this._fields, form.getFields())
        }
    },

    /**
     * Checks if GPS is being collected and the user is on campus, to be submitted with forms
     *
     * @return {Boolean} Is the user on campus?
     */
    _isUserOnCampus: function() {
        if (Analytics.gpsCollector) {
            var gpsObject = Analytics.gpsCollector.getCurrentGpsObject()

            if (gpsObject) {
                return Analytics.gpsCollector.isGpsInBounds(gpsObject)
            }
        }
        return false
    },
}

export default Registration
